import { CandyGuard } from '@metaplex-foundation/mpl-candy-guard';
import { GpaBuilder } from '../../../utils/GpaBuilder.mjs';
import { toCandyGuard } from '../models/CandyGuard.mjs';

// -----------------
// Operation
// -----------------

const Key = 'FindCandyGuardsByAuthorityOperation';

/**
 * Find all Candy Guards matching by a given authority.
 *
 * ```ts
 * const candyGuards = await metaplex
 *   .candyMachines()
 *   .findAllCandyGuardsByAuthority({ authority: new PublicKey('...') });
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findCandyGuardsByAuthorityOperation = _findCandyGuardsByAuthorityOperation;
// eslint-disable-next-line @typescript-eslint/naming-convention
function _findCandyGuardsByAuthorityOperation(input) {
  return {
    key: Key,
    input
  };
}
_findCandyGuardsByAuthorityOperation.key = Key;

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findCandyGuardsByAuthorityOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      authority
    } = operation.input;
    const {
      programs,
      commitment
    } = scope;
    const candyGuardProgram = metaplex.programs().getCandyGuard(programs);
    const query = CandyGuard.gpaBuilder(candyGuardProgram.address).addFilter('authority', authority);
    const gpaBuilder = new GpaBuilder(metaplex, candyGuardProgram.address);
    gpaBuilder.mergeConfig({
      ...query.config,
      commitment
    });
    return gpaBuilder.getAndMap(account => toCandyGuard(account, metaplex));
  }
};

export { findCandyGuardsByAuthorityOperation, findCandyGuardsByAuthorityOperationHandler };
//# sourceMappingURL=findCandyGuardsByAuthority.mjs.map
